// this must match the game states
// on the server.
const GameStates  = {
    error: -666,
    challengerPaymentFailed: -3001,
    champPaymentFailed: -3000,
    cancelled: -2000,
    start: -1,
    pendingChampionPayment: -10,
    open: 0,
    pendingChallengerPayment: 1,
    started: 5,
    waitingForPayout: 40,
    completed: 50,
};
export default GameStates;